import React from "react";
import CommonModal from "../../../../components/Common/CommonModal";
import CommonButton from "../../../../components/buttons/CommonButton";
import CommonInputValor from "../../../../components/forms/CommonInputValor";
import {
  handleChange,
  handleChangeFile,
  handleChangeNameValue,
} from "../../../../helpers/handleFormChanges";
import CommonInputDate from "../../../../components/forms/CommonInputDate";
import CommonInputFile from "../../../../components/forms/CommonInputFile";
import CommonInput from "../../../../components/forms/CommonInput";
import PropTypes from "prop-types";

function SubstituirImpostoModal({ modalHook, valuesHook, substituirImposto }) {
  const { substituirImpostoModal, setSubstituirImpostoModal } = modalHook;
  const { values, setValues } = valuesHook;

  return (
    <CommonModal
      title="Substituir documento"
      is_open_modal={substituirImpostoModal}
      set_is_open_modal={setSubstituirImpostoModal}
      size="lg"
      buttons={
        <CommonButton
          key={`substituir-imposto`}
          onClick={substituirImposto}
          color="success"
        >
          Upload
        </CommonButton>
      }
    >
      <div className="row">
        <div className="col-md-6 mb-3">
          <CommonInputValor
            label="Novo valor"
            id="valor"
            value={values.valor}
            onChange={(e) => {
              handleChangeNameValue("valor", e.target.value, values, setValues);
            }}
            required
          />
        </div>
        <div className="col-md-6 mb-3">
          <CommonInputDate
            label="Nova data de vencimento"
            id="vencimento"
            value={values.vencimento}
            onChange={(e) => {
              handleChange(e, values, setValues);
            }}
            required
          />
        </div>
      </div>
      <div className="row">
        <div className="col-md-6 mb-3">
          <CommonInput
            label="Código de barras"
            id="codigoBarras"
            value={values.codigoBarras}
            onChange={(e) => {
              handleChange(e, values, setValues);
            }}
          />
        </div>
        <div className="col-md-6 mb-3">
          <CommonInputFile
            label="Selecione o arquivo"
            id="arquivo"
            onChange={(e) => handleChangeFile(e, values, setValues)}
            accept="application/pdf"
            required
          />
        </div>
      </div>
    </CommonModal>
  );
}

SubstituirImpostoModal.propTypes = {
  modalHook: PropTypes.shape({
    substituirImpostoModal: PropTypes.bool.isRequired,
    setSubstituirImpostoModal: PropTypes.func.isRequired,
  }).isRequired,
  valuesHook: PropTypes.shape({
    values: PropTypes.object.isRequired,
    setValues: PropTypes.func.isRequired,
  }).isRequired,
  substituirImposto: PropTypes.func.isRequired,
};

export default SubstituirImpostoModal;
